import { PrankDefinition, PrankIntensity, Intensity } from './types';
import tiltPrank from './tilt';
import phantomScrollPrank from './phantom-scroll';
import lazyCursorPrank from './lazy-cursor';
import comicSansPrank from './comic-sans';
import fadePrank from './fade';
import greyscalePrank from './greyscale';
import breathingPrank from './breathing';

const ALL_PRANKS: PrankDefinition[] = [
  tiltPrank,
  phantomScrollPrank,
  lazyCursorPrank,
  comicSansPrank,
  fadePrank,
  greyscalePrank,
  breathingPrank,
];

const INTENSE_PREFIX = 'ntns';
const NORMAL_PREFIX = 'nrml';
const INTENSE_CHANCE = 0.025;
const APRIL_FOOLS_INTENSE_CHANCE = INTENSE_CHANCE * 4;

const CODE_TO_PRANK: Record<string, PrankDefinition> = {};
ALL_PRANKS.forEach(prank => {
  CODE_TO_PRANK[prank.namedCode] = prank;
  CODE_TO_PRANK[prank.hexCode] = prank;
});

interface PrankLookupResult {
  prank: PrankDefinition;
  intensity: PrankIntensity;
}

export const lookupPrank = (code: string): PrankLookupResult | null => {
  const isIntense = code.startsWith(INTENSE_PREFIX);
  const isForcedNormal = !isIntense && code.startsWith(NORMAL_PREFIX);
  let rawCode = code;
  if (isIntense) rawCode = code.slice(INTENSE_PREFIX.length);
  else if (isForcedNormal) rawCode = code.slice(NORMAL_PREFIX.length);

  const prank = CODE_TO_PRANK[rawCode];
  if (!prank) return null;

  let intensity: PrankIntensity;
  if (isIntense) intensity = Intensity.INTENSE;
  else if (isForcedNormal) intensity = Intensity.NORMAL;
  else intensity = Math.random() < INTENSE_CHANCE ? Intensity.INTENSE : Intensity.NORMAL;

  return { prank, intensity };
};

export const selectRandomPrank = (disabledCodes: string[] = []): PrankLookupResult | null => {
  const disabled = new Set(disabledCodes.map(c => c.toLowerCase()));
  const enabled = ALL_PRANKS.filter(
    p => !disabled.has(p.namedCode.toLowerCase()) && !disabled.has(p.hexCode.toLowerCase()),
  );
  if (enabled.length === 0) return null;

  const prank = enabled[Math.floor(Math.random() * enabled.length)];
  const intensity: PrankIntensity = Math.random() < APRIL_FOOLS_INTENSE_CHANCE ? Intensity.INTENSE : Intensity.NORMAL;

  return { prank, intensity };
};
